import React, { useEffect, useState } from 'react';
import axios from '../axios';

const PlaceDetail = ({ placeId, onBack, onReserve }) => {
  const [place, setPlace] = useState(null);
  const [contents, setContents] = useState([]);
  const googleMapsView = (place) => {
    if (place.address && place.address.trim() !== '') {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(place.address)}`;
    }
    const url = place.google_map_url || '';
    return url.includes('/embed') ? url.replace('/maps/embed?', '/maps?') : url;
  };

  useEffect(() => {
    if (!placeId) return;
    axios
      .get(`/api/places/${placeId}`)
      .then((res) => {
        setPlace(res.data.place);
        setContents(res.data.contents || []);
      })
      .catch(() => {
        setPlace(null);
        setContents([]);
      });
  }, [placeId]);

  const renderContent = (content) => {
    switch (content.content_type) {
      // テキスト本文
      case 1:
        return (
          <p key={content.id} className="mb-4" style={{ whiteSpace: 'pre-line' }}>
            {content.body}
          </p>
        );
      // 見出し
      case 2:
        return (
          <h2 key={content.id} className="h5 font-weight-bold mt-4 mb-3">
            {content.body}
          </h2>
        );
      // 画像
      case 3:
        return (
          <figure key={content.id} className="mb-4">
            <img src={content.photo_url_medium} alt={content.body || ''} className="w-100"/>
            {content.body && (
              <figcaption className="mt-1 text-muted">
                {content.body}
              </figcaption>
            )}
          </figure>
        );
      // Youtubeコード
      case 4:
        return (
          <div key={content.id} className="mb-4 embed-responsive embed-responsive-16by9" dangerouslySetInnerHTML={{ __html: content.body }}
          />
        );
      // 引用
      case 5:
        return (
          <blockquote key={content.id} className="blockquote pl-3 border-left mb-4">
            <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>
              {content.body}
            </p>
          </blockquote>
        );
      default:
        return null;
    }
  };

  if (!place) return null;

  return (
    <main className="bg-white min-vh-100 pb-5">
      <div className="container col-md-8 col-lg-6 py-3">
        <button className="btn text-gray px-0 mb-2" onClick={onBack}>← 戻る</button>

        <img src={place.image_data_medium || place.image_data} alt={place.name} className="w-100 mb-3" />
        <h1 className="h4 font-weight-bold mb-3">{place.name}</h1>
        {contents.map(renderContent)}
        {place.address && (
          <>
            <h2 className="h5 font-weight-bold mb-2">詳細情報</h2>
            {place.address && <p className="mb-2">住所：{place.address}</p>}
            {place.stations && <p className="mb-2">交通：{place.stations}</p>}
            {place.opening_hours && <p className="mb-2">営業時間：{place.opening_hours}</p>}
            {place.description && <p className="mb-1">詳細：
            <a href={place.description} target="_blank" rel="noopener noreferrer" className="text-primary">{place.description}</a></p>}
          </>
        )}

        {(place.google_map_url || place.address) && (
          <>
            <div className="mb-3 mt-2">
              <iframe
                title="map"
                src={place.google_map_url || `https://www.google.com/maps?q=${encodeURIComponent(place.address)}&output=embed`}
                className="w-100"
                height="240"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <p className="text-right small">
              <a href={googleMapsView(place)} target="_blank" rel="noopener noreferrer">
                大きい地図で見る
              </a>
            </p>
          </>
        )}

        <div className="fixed-bottom d-flex px-2 py-2 bg-white border-top">
          <button
            type="button"
            className="flex-fill mr-2 py-3 rounded text-white border-0"
            style={{ background: '#FB4C58' }}
            onClick={onBack}
          >
            戻る
          </button>

          {/* 8/4JOYSOUND予約不要に */}
          {/* 10/15 再度復活 */}
          <button
            type="button"
            className="flex-fill ml-2 py-3 text-white rounded border-0"
            style={{ background: '#FB4C58' }}
            onClick={() =>
              typeof onReserve === 'function' && onReserve(place)
            }
          >
            この会場を選択
          </button>
        </div>
      </div>
    </main>
  );
};

export default PlaceDetail;
